/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import "@9softstudio/react-monthpicker/dist/reactmonthpicker.css";
import 'moment/locale/es';
import { closelightbox } from "../../../util/Functions";
import * as API from '../../../http/api';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import * as FORMAT from 'react-day-picker/moment';
import { format } from "../../../util/DateUtil";
import { REGEX_EMAIL } from "../../../util/RegEx";

const CargoDisputaCacao = (props) => {

    const [data, setData] = useState({});
    const [startDate, setStartDate] = useState(new Date());
    const [dateDesc,setDateDesc] = useState(new Date());
    const [sectionOptions,setSectionOptions] = useState([
        {"id":"0","input":false,"text":"No reconozco"},
        {"id":"1","input":false,"text":"Importe diferente"},
        {"id":"2","input":false,"text":"Duplicidad de cargos"},
        {"id":"3","input":false,"text":"Rechazo en el comercio y se realizó pago con otro medio de pago*."},
        {"id":"4","input":false,"text":"Cancelación o devolución no aplicada*"},
        {"id":"5","input":false,"text":"Transacción de Internet"},
        {"id":"6","input":false,"text":"Aclaración de Transacción de Cajero Automático."},
        {"id":"7","input":false,"text":"Cargo periódico o recurrente cancelado*"},
        {"id":"8","input":false,"text":"Reservación no solicitada. Tarjetahabiente no reconoce reservación"},
        {"id":"9","input":true,"text":"Otro. Especifique :"},
    ]);
    const [disabled,setDisabled] = useState(true);
    const [msnDesc,setDesc] = useState("");
    const [msnError,setMsnError] = useState("");
    const [section,setSection] = useState(true);
    const [textSection,setTextSection] = useState("");
    const [inputSection,setInputSection] = useState(false);
    const [reason,setReason] = useState("");
    const [check,setCheck] = useState([
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false,
            "value":""
        }
    ])
    const [name,setName] = useState("");
    const [email,setEmail] = useState("");
    var   [emailSend,setEmailSend] = useState("");
    const [emailDisable,setEmailDisable] = useState(false)
    const [disabledEnvio,setDisabledEnvio] = useState(true);
    const [sendEmail, setSendEmail] = useState(false);
    const [cardNumber, setCardNumber] = useState("");

    useEffect(() => {
        setData(props.data);
        if (props.config["actions"].indexOf("sendEmail") > -1) {
            setSendEmail(true);
        }
        init();
    }, []);

    const init  = async ()=>{
        setName(props.customer.name);
        setEmail(props.customer.email);
    }
 
    const resetChecks = ()=>{
        check.map(data=>{
            data.check = false;
        })
    }

    const handleSectionOption = (event)=>{
        let value = event.target.value;
        let aux;
        resetChecks();
        sectionOptions.map((data,index)=>{
            if(data.text === value){
                aux = data;
                setInputSection(aux.input)
                setSection(false)
                setDisabled(false)
                setTextSection(value)
                check[index].check = true;
            }
        })
    }

    const resetSection = () =>{
        setSection(true);
        setDisabled(true)
        resetChecks();
        setTextSection("")
    }

    const formatDate = (date)=>{
        return format(date);
    }

    const validate = ()=>{
        
        if(textSection.length === 0){
            setMsnError("Seleccione el motivo de la reclamación")
            props.changeLoader(false);
            return false;
        }

        if(check[9].check && reason.trim().length ==0){
            setMsnError("Campo obligatorio");
            props.changeLoader(false);
            return false;
        }else{
            setDisabled(false)
            check[9].value = reason;
            return true;
        }
    }

    const descarga = async()=>{
        props.changeLoader(true);
        if(!validate()){
            return;
        }
        var data = {
            "type": "disputa-cacao",
            "content": {
                "card": {
                    "name": name,
                    "number": cardNumber,
                    "amount": props.data.amount.toString(),
                    "currency": props.data.currency,
                    "total": props.data.amount.toString(),
                },
                "claims": check,
                "txs": [
                    {
                        "date":formatDate( props.data.cdate),
                        "store":  props.data.concept,
                        "auth": props.data.remote_account?.authorization_number,
                        "amount":  props.data.amount.toString(),
                        "currency":  props.data.currency
                    }
                ],
                "comments": {
                    "value": msnDesc,
                    "date": formatDate(dateDesc)
                }
            },
            "url": "signed",
            "agent_uuid": JSON.parse(localStorage.session).uuid,
        }
        
        var request = await API.service('cartasDocs', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if(request.status === 200){

            if(request.data.data.response === "OK"){
                var dataResult = request.data.data.widget[0].content.url;
                props.changeAlert(true, 'success', 'Carta de contra cargos creada con éxito');
                window.open(dataResult, '_blank');
            }else{
                props.changeAlert(true, 'error', 'Error al crear la carta de contra cargos.');
            }
        }
        closelightbox();
        props.changeLoader(false);
    }

    const enviar = async ()=>{
        props.changeLoader(true);
        if(!validate()){
            return;
        }

        var data = {
            "type": "disputa-cacao",
            "content": {
                "card": {
                    "name": name,
                    "number": cardNumber,
                    "amount": props.data.amount.toString(),
                    "currency": props.data.currency,
                    "total": props.data.amount.toString(),
                },
                "claims": check,
                "txs": [
                    {
                        "date":formatDate( props.data.cdate),
                        "store":  props.data.concept,
                        "auth": props.data.remote_account?.authorization_number,
                        "amount":  props.data.amount.toString(),
                        "currency":  props.data.currency
                    }
                ],
                "comments": {
                    "value": msnDesc,
                    "date": formatDate(dateDesc)
                }
            },
            "url": "signed",
            "agent_uuid": JSON.parse(localStorage.session).uuid
        }
        
        var request = await API.service('cartasDocs', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if(request.status === 200){

            if(!REGEX_EMAIL.test(emailSend)){   
                emailSend = email;
            }

            if(request.data.data.response === "OK"){
                var url = request.data.data.widget[0].content.url;
                var dataSend ={
                    url:url,
                    email: emailSend,
                    docName: "Contra cargo no reconocido Cacao",
                    name:name
                };


                var requestSend = await API.service('cartasDocsSend', dataSend, props.pos, props.changeAlert, props.changeLoader, props.history);
                if(requestSend.status == 200 && requestSend.data.data.response === "OK"){
                    props.changeAlert(true, 'success', 'Carta de contra cargos enviada con éxito');
                }else{
                    props.changeAlert(true, 'error', 'Error al enviar la carta de contra cargos.');
                }
                
            }else{
                props.changeAlert(true, 'error', 'Error al enviar la carta de contra cargos.');
            }
        }
        closelightbox();
        props.changeLoader(false);

    }

    const changeDateDesc = (event)=>{ 
        var value = event.toJSON().substring(0, 10);
        setDateDesc(value)
    }

    const changeReason = (event)=>{ 
        var value = event.target.value;
        if(value.trim().length > 0){
            setReason(value)
            setDisabled(false)
        }else{
            setReason("")
            setDisabled(true)
        }
    }

    const editEmail = ()=>{
        if(emailDisable){
            setEmailDisable(false);
            setDisabledEnvio(false)
        }else{
            setEmailDisable(true);
            setDisabledEnvio(true)
        }
    }

    const newEmailSend = (event) =>{
        var value = event.target.value;
        if ( !REGEX_EMAIL.test(value)) {
            setDisabledEnvio(true)
            setEmailSend(email)
            return;
        } else {
            setDisabledEnvio(false)
            setEmailSend(value);
        }   
    }

    return (<div className="card carta-doc">
        <div className="text-right modal_header_close">
            {
              <div
                className="tooltip"
                style={{ marginRight: "10px", cursor: "pointer" }}
              >
                <span  className="tooltiptext tooltip-bottom">Descargar</span>
                <i onClick={descarga} className="ibon-download"  ></i>
              </div>
            }

            <div className="tooltip">
              <span className="tooltiptext tooltip-bottom">Cerrar</span>
              <i className="ibon-close tap" onClick={closelightbox}></i>
            </div>
        </div>
        <h3 className="modal_header_title">Cargos no reconocidos cacao </h3>
        
        <div className="">
          
            <div className="carta-form">

                <div className="carta-form-personal">
                    <p><span>Nombre del Tarejahabiente:</span> {name} </p>
                    <p><span>Número de Tarjeta: <input type="number" value={cardNumber}  style={{width:"50%",border:"1px solid #3743aa"}} placeholder="Numero de la tarjeta" className="ibon-account" onChange={e => setCardNumber(e.target.value)} /></span>  </p>
                    <p><span style={{marginRight:"15px"}}>Monto Total Disputado: {props.data.amountFormated}</span> <span> Moneda {props.data.currency}</span></p>
                    <p><span>Cantidad de Transacciones Disputadas:1</span></p>
                </div>
              
                <div className="carta-form-section">
                    <h3>Motivo de Reclamación</h3>
  
                    {section &&
                        <ul>
                            {sectionOptions.map(data=>{
                                return (
                                <li key={data.text}>
                                    <input type="checkbox"  style={{marginTop:"4px"}} onChange={handleSectionOption.bind(this)} value={data.text} />
                                    <span> 
                                        {data.text} 
                                        {data.input &&
                                            <span>______________</span>
                                        }
                                    </span>
                                </li>)
                            })
                            }
                        </ul>
                    }
                    {!section &&
                        <ul>
                            <li><input style={{marginTop:"4px"}}  type="checkbox" checked onChange={resetSection}/>  
                                <span>
                                    {textSection}
                                    {inputSection &&
                                        <input type="text" style={{width:"50%"}} placeholder="Write the alternate means of payment details." className="ibon-account" onChange={changeReason}/>
                                    }
                                </span>
                            </li>
                        </ul>
                    }

                </div>

                <div className='container-table-default'>
                    <h2>*Adjuntar comprobante</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Fecha de Transacción</th>
                                <th>Comercio</th>
                                <th>N Autorización</th>
                                <th>Monto</th>
                                <th>Moneda</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formatDate(props.data.cdate)}</td>
                                <td>{props.data.concept}</td>
                                <td>{props.data.remote_account?.authorization_number}</td>
                                <td>{props.data.amountFormated}</td>
                                <td>{props.data.currency}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            
                <div className="carta-form-section">
                    <h2>Comentarios adicionales del tarjetahabiente:</h2>

                    <p>Este espacio debe utilizarlo el tarjetahabiente para describir detalladamente el motivo de su reclamo de manera que todas las partes involucradas entiendan el mismo.</p>
                
                    <textarea onChange={(e)=>{setDesc(e.target.value)}}  className="carta-textarea"></textarea>
                    <p>
                        Date
                        <DayPickerInput
                            style={{height: '30px', width: '25%',margin:'0 10px'}}
                            onDayChange={changeDateDesc}
                            placeholder='Select the date'
                            format="DD-MM-YYYY"
                            value={startDate}
                            inputProps={{
                                readOnly: true
                            }}
                            formatDate={FORMAT.default.formatDate}
                            parseDate={FORMAT.default.parseDate}
                            dayPickerProps={{
                                months: ["Ene", "Feb", "Mar","Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                                pagedNavigation: true,
                                numberOfMonths: 1,
                            }}
                        />
                    </p>

                    {sendEmail &&
                        <div className="envioCartaEmail">
                            <p>Ingresar nuevo email <i className="tap ibon-chevron-down" onClick={editEmail}></i>  </p>
                            {emailDisable &&
                                <input type="text"  style={{width:"50%"}} placeholder="Email..." className="ibon-account" onChange={newEmailSend.bind(this)} />
                            }

                            {emailDisable &&
                                <p>Se enviará a {emailSend}, {name} </p>
                            }

                            {!emailDisable &&
                                <p>Se enviará a {email}, {name}</p> 
                            }

                            <div style={{marginRight:"60px"}} className="carta-footer-col-3">
                                {
                                    <div className={ disabled ? 'disable bigButton  pnl-btn-save  pos-left' : 'bigButton pnl-btn-save  pos-left'}>
                                        <button  type="submit" onClick={enviar}>Enviar</button>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>

                <div className="carta-form-section">

                    <div className="carta-footer">
                        <div className="carta-footer-col">
                            <div className="bigButton pos-left">
                                <button onClick={closelightbox} >Cancelar</button>
                            </div>
                        </div>
                        <div className="carta-footer-col-3">
                            <div className={disabled ? 'disable bigButton pos-right pnl-btn-save' : 'bigButton pos-right pnl-btn-save'}>
                                <button disabled={disabled} type="submit" onClick={descarga}>Descargar</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>)
}

export default CargoDisputaCacao;